import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import Form from 'antd/es/form/Form';
const FeedBackProvider = (props) => {
  const api = new API();
  const [feedbackTableFilter, setFeedbackTableFilter] = useState({
    page: 1,
    limit: 20,
    exam_id:"",
  })
  const [feedBackList, setFeedBackList] = useState([]);
  const [feedBackListLoader, setFeedBackListLoader] = useState(false);
  const [examListFD, setExamListFD] = useState([]);
  const [examListFDLoader, setExamListFDLoader] = useState(false);
  const [getFeedBackDetail, setGetFeedBackDetail] = useState({});
  const [getFeedBackDetailLoader, setGetFeedBackDetailLoader] = useState(false);
  const [feedStatusFormLoader, setFeedStatusFormLoader] = useState(false);
  const [feedEmailFormLoader, setFeedEmailFormLoader] = useState(false);
  const [feedStatusForm] = Form.useForm();
  const [feedSendEmailForm] = Form.useForm();
  const fetchFeedBackList = async () => {
    setFeedBackListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("feedback/feedback_list", {...feedbackTableFilter}, (err, res) => {
        if (res?.data?.status === 200) {
          setFeedBackList(res?.data?.data);
        } else {
          setFeedBackList([]);
        }
        setFeedBackListLoader(false);
      }));
  }
  const fetchExamFeedBackDList = async () => {
    setExamListFDLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("feedback/exam_list", {}, (err, res) => {
        if (res?.data?.status === 200) {
          const ress = res?.data?.data?.map(item => {
            return {
              label: item?.name,
              value: item?._id
            }
          })
          setExamListFD(ress);
        } else {
          setExamListFD([]);
        }
        setExamListFDLoader(false);
      }));
  }

  const fetchFeedBackDetail = async (id) => {
    if(!id) return;
    setGetFeedBackDetailLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getSingle("feedback/feedback_details",id , (err, res) => {
        if (res?.data?.status === 200) {
          setGetFeedBackDetail(res?.data?.data);
          feedStatusForm.setFieldsValue({
            status: res?.data?.data?.fetch_feedback?.tickets_status,
            not_calculate: res?.data?.data?.fetch_feedback?.not_calculate===1?true:false
          });
          feedSendEmailForm.setFieldsValue({
            email_to: res?.data?.data?.get_user?.email
          })
        } else {
          setGetFeedBackDetail({});
        }
        setGetFeedBackDetailLoader(false);
      }));
  }

  const fetchFeedStatusUpdate = async (id,data) => {
    if(!id || !data) return;
    setFeedStatusFormLoader(true);
    const result = {
      status: data?.status,
      not_calculate: data?.not_calculate===true?1:0
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("feedback/feedback_status_update",id,result, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setFeedStatusFormLoader(false);
      }));
  }

  const sendEmailFeed = async (data,id) => {
    if(!id || !data) return;
    data["feedback_id"] = id;
    setFeedEmailFormLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
    (await api.create("feedback/send_feedback_email",data, (err, res) => {
      if (res?.data?.status === 200) {
        Widget.showMessage("success", res?.data?.message);
        feedSendEmailForm.resetFields();
        fetchFeedBackDetail(id);
      } else {
        Widget.showMessage("error", err?.response?.data?.message);
      }
      setFeedEmailFormLoader(false);
    }));
  }
  
   return (
    <Context.Provider value={{
      ...props,
      fetchFeedBackList,
      feedbackTableFilter, setFeedbackTableFilter,
      feedBackList, setFeedBackList,
      feedBackListLoader, setFeedBackListLoader,
      fetchExamFeedBackDList,
      examListFD, setExamListFD,
      examListFDLoader, setExamListFDLoader,
      fetchFeedBackDetail,
      getFeedBackDetail, setGetFeedBackDetail,
      getFeedBackDetailLoader, setGetFeedBackDetailLoader,
      feedStatusForm,
      feedSendEmailForm,
      feedStatusFormLoader, setFeedStatusFormLoader,
      fetchFeedStatusUpdate,
      feedEmailFormLoader, setFeedEmailFormLoader,
      sendEmailFeed
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default FeedBackProvider;

